import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RilevamentoScambiSempliciDTO } from '../models/models/pages/rilevamento-semplici';

@Injectable({ providedIn: 'root' })
export class RilevamentoScambiSempliciService {
    private baseUrl = `${environment.baseApiUrl}/rilevamento-scambi-semplici`;

    private cache = new Map<any, Observable<any[]>>();

    constructor(private http: HttpClient) {}

    // LIST
    list(params?: { page?: number; size?: number; sort?: string }): Observable<RilevamentoScambiSempliciDTO[]> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http.get<RilevamentoScambiSempliciDTO[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true
        });
    }

    // GET by id
    get(id: number): Observable<RilevamentoScambiSempliciDTO> {
        return this.http.get<RilevamentoScambiSempliciDTO>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    // CREATE
    create(payload: Omit<RilevamentoScambiSempliciDTO, 'id'>): Observable<RilevamentoScambiSempliciDTO> {
        return this.http.post<RilevamentoScambiSempliciDTO>(this.baseUrl, payload, { withCredentials: true });
    }

    // UPDATE
    update(entity: RilevamentoScambiSempliciDTO): Observable<RilevamentoScambiSempliciDTO> {
        return this.http.put<RilevamentoScambiSempliciDTO>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    // PATCH
    partialUpdate(id: number, patch: Partial<RilevamentoScambiSempliciDTO>): Observable<RilevamentoScambiSempliciDTO> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<RilevamentoScambiSempliciDTO>(`${this.baseUrl}/${id}`, patch, {
            headers,
            withCredentials: true
        });
    }

    // DELETE
    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    getOrFetch(deviatoioId: any, fetchFn: () => Observable<any[]>): Observable<any[]> {
        const cacheKey = deviatoioId?.id;

        if (!cacheKey) {
            return of([]);
        }

        if (!this.cache.has(cacheKey)) {
            this.cache.set(cacheKey, fetchFn().pipe(shareReplay(1)));
        }

        return this.cache.get(cacheKey)!;
    }
}
